import { render } from "./StudyManagment.vue?vue&type=template&id=600e9f30&scoped=true"
import script from "./StudyManagment.js?vue&type=script&lang=js"
export * from "./StudyManagment.js?vue&type=script&lang=js"

import "./StudyManagment.vue?vue&type=style&index=0&id=600e9f30&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600e9f30"]])

export default __exports__